/* eslint no-debugger: "off" */
import {
  StoreUserAuthenticateRequest,
  StoreUserAuthenticateResponse,
  FetchStoreUserByIdResponse
} from 'AppTypes'
import { StoreUser } from '@app/models'

import axios from '@utils/axios-client'

/* eslint no-debugger: "off" */
export async function fetchStoreUserById (id: string): Promise<StoreUser> {
  const response: FetchStoreUserByIdResponse = await axios.get(`/api/v1/StoreUser/${id}`)
  return new StoreUser(response.data)
}

export async function authenticate (payload: StoreUserAuthenticateRequest): Promise<StoreUser> {
  const response: StoreUserAuthenticateResponse = await axios.post('/api/v1/StoreUser/Authenticate', payload)
  // ShopApi wraps this endpoint in ApiResult<TokenDto> ({ data, success, status }),
  // unlike the other StoreUser endpoints which return the DTO flat. Accept both so
  // the token is stored either way — without this, nothing reaches localStorage and
  // the app bounces straight back to /login.
  const tokenData: any = (response.data as any)?.data ?? response.data
  if (tokenData.jwtToken)
    localStorage.setItem('jwtToken', tokenData.jwtToken)
  if (tokenData.refreshToken)
    localStorage.setItem('refreshToken', tokenData.refreshToken)
  if (tokenData.id)
    localStorage.setItem('storeUserId', tokenData.id)
  return new StoreUser(tokenData)
}
